import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import CRM from "@/assets/crm.svg";
import { ClientOutlinedButton, ClientButton } from "@/components/button";
import { useParams } from "react-router-dom";
import useCRM from "@/hooks/useCRM";
import { useQuery } from "@/utils";

const useStyles = makeStyles({
  root: {},
  name: {
    fontSize: "20px",
    fontFamily: "Roboto",
    color: "#fff",
    textAlign: "center",
    paddingBottom: 31,
  },
  back: {
    position: "absolute",
    left: 17,
    top: 28,
    color: "white",
    fontSize: 27,
    cursor: "pointer",
  },
  contentWrapper: {
    padding: "0 16px 41px",
  },
  paper: {
    minHeight: 592,
    padding: "19px 19px",
  },
  imgWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  crmImage: {
    margin: "128px auto 19px",
    width: "95px",
  },
  title: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: 500,
    color: "#000",
    marginBottom: "4px",
  },
  textWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 64,
  },
  text: {
    width: 243,
    textAlign: "center",
    color: "#6c727c",
    fontSize: "16px",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 16,
  },
});

const CRMLogin = () => {
  const classes = useStyles();
  const { merchantId } = useParams();
  const merchant = useSelector((state) => state.merchant);
  const { id } = useQuery();
  const newWait = useSelector((state) => state.waitlist.edit.value);
  const { phone, name } = newWait;

  const {
    isHasOnBoardingRule,
    onBoardingRule,
    handleConfirmCRM,
    handleSkipCRM,
    isFirstLoad,
  } = useCRM(merchantId, "client");

  return (
    <div>
      <div className={classes.name}>{merchant ? merchant.name : ""}</div>
      <div className={classes.contentWrapper}>
        <Paper className={classes.paper}>
          {isFirstLoad && (
            <>
              <div className={classes.imgWrapper}>
                <img src={CRM} alt="crm" className={classes.crmImage} />
              </div>
              <div className={classes.title}>
                {isHasOnBoardingRule
                  ? `You’ll earn ${onBoardingRule.giftContent?.number} points`
                  : "Join as Member for Free"}
              </div>
              <div className={classes.textWrapper}>
                <div className={classes.text}>
                  {isHasOnBoardingRule
                    ? "Join as member for free and enjoy ongoing exclusive membership benefits"
                    : "Join our membership and enjoy ongoing exclusive membership benefits"}
                </div>
              </div>
              <div className={classes.btnWrapper}>
                <ClientButton
                  background="#FFA439"
                  textcolor="#fff"
                  onClick={() =>
                    handleConfirmCRM({ phone, name }, () => handleSkipCRM(id))
                  }
                >
                  Join the Membership for Free
                </ClientButton>
              </div>
              <div
                className={classes.btnWrapper}
                onClick={() => handleSkipCRM(id)}
              >
                <ClientOutlinedButton>Skip</ClientOutlinedButton>
              </div>
            </>
          )}
        </Paper>
      </div>
    </div>
  );
};

export default CRMLogin;
